import { render, staticRenderFns } from "./InvoiceHistory.vue?vue&type=template&id=31f64710&scoped=true&"
import script from "./InvoiceHistory.vue?vue&type=script&lang=js&"
export * from "./InvoiceHistory.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceHistory.vue?vue&type=style&index=0&id=31f64710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f64710",
  null
  
)

component.options.__file = "InvoiceHistory.vue"
export default component.exports